import React, { useEffect, useState } from "react";
import Image from "next/image";
import { useRouter } from "next/router";
export default function index({
  title = null,
  img = null,
  underline = true,
  smallImage = true,
  largeImage = true,
}) {
  const { locale } = useRouter();
  return (
    <div className=" bg-[#010140] pt-[70px] ">
      <div className="flex items-center justify-between md:h-[240px] h-[120px] py-[30px] md:py-[60px] max-w-[90rem] mx-auto min-h-max relative ">
        {title && (
          <div className="responsive z-10 max-w-[85%]">
            <h2
              className="text-[#F6F6F6] text-[28px] md:text-[32px] lg:text-[48px] font-[590] md:leading-[65px]"
              id="titleText"
            >
              {title}
            </h2>

            {underline && (
              <hr
                className={`h-[3px!important] md:h-[5px!important] bottomborder  w-[60%!important]
                ${locale == "ar" ? "mt-2" : ""}`}
              />
            )}
          </div>
        )}{" "}
        {img != null && (
          <div className="absolute  w-full flex justify-end max-w-[90rem] ">
            <div
              className={`w-[120px] h-[120px] scale-125 sm:w-[182px] sm:scale-100 sm:h-[182px] md:w-[240px]  md:h-[240px]  lg:w-[320px]  lg:h-[320px] relative ${
                locale == "ar" ? "scale-x-[-1.25] sm:scale-x-[-1]" : ""
              } ${
                smallImage && largeImage
                  ? "block"
                  : largeImage && !smallImage
                  ? "mds:hidden"
                  : !largeImage && smallImage
                  ? "sm:block  xl:hidden"
                  : ""
              } `}
            >
              <Image alt={title} src={`/${img}.png`} layout="fill" />
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
